import { render, staticRenderFns } from "./UbiNotify.vue?vue&type=template&id=c517a832&"
import script from "./UbiNotify.vue?vue&type=script&lang=js&"
export * from "./UbiNotify.vue?vue&type=script&lang=js&"
import style0 from "./UbiNotify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports